import { render, staticRenderFns } from "./new-unidades.vue?vue&type=template&id=580ad1ae&"
import script from "./new-unidades.vue?vue&type=script&lang=js&"
export * from "./new-unidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports